export default function BulkArchiveReportInstancesConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  reportsDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmArchive = _handleConfirmArchive;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmArchive($event) {
    loaderService.showViewLoader = true;
    const idList = {};
    idList.ids = vm.reportInstanceIds;
    return reportsDataService.bulkArchiveReportInstances(idList).then(() => {
      alerts.success('All selected Report Instances were successfully archived.');
      $rootScope.$broadcast(`reports.myReports.reportType.reportInstancesArchived`, { uniqueId: vm.reportTypeId }); // eslint-disable-line max-len
      _closeDialog($event);
      ssDialogService.hide(ssDialogService.dialogs.reports.bulkArchiveReportInstancesDialog);
    }).catch(() => {
      alerts.error('An error occurred while deleting the selected Report Instances.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.bulkArchiveReportInstancesConfirmDialog);
  }
}

BulkArchiveReportInstancesConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'reportsDataService',
  'loaderService',
  'ssDialogService'
];
